// extracted by mini-css-extract-plugin
export default {"single-offer-container":"SingleOffer_single-offer-container__oR4zV","image-container":"SingleOffer_image-container__5dwox","image":"SingleOffer_image__HtJL4"};